function initSolutions(){
    if($(".solutions__readmore").length > 0){
        $(".solutions__readmore").on("click keypress", function(e){
            if(e.type === "click" || (e.type === "keypress" && e.which == 13)){
                //click or enter key
                var container = $(this).siblings(".solutions__quicklinks-container");
                if(container.hasClass("extended")){
                    container.removeClass("extended");
                } 
                else {
                    container.addClass("extended");
                }
            }
        });
    }
}